module.exports = "/images/report-icon.svg?7e3b9f1f809bbba1dcc09770935d0430";